import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'
import toNumber from 'lodash-es/toNumber'

import { Product, type User } from '@infura/packages.api'
import { ServiceAddon, ServiceTier } from '@infura/packages.uks'
import { User as DBUser } from '@infura/packages.user-db'

import { KSService } from './servicePlan'

export const mfaEnabledPath = ['mfa', 'enabled']
export const stripeCustomerIdPath = ['payment_providers', 'stripe', 'customer_id']

export const getUserSubscriptionTier = (servicePlan?: KSService): ServiceTier => {
  const tier = servicePlan?.tier || ''
  return ServiceTier[tier.toUpperCase()] || ServiceTier.CORE
}

export const isEnterpriseUser = (servicePlan?: KSService): boolean => {
  return getUserSubscriptionTier(servicePlan) === ServiceTier.ENTERPRISE
}

export const getUserTrafficAddonQuantity = (servicePlan?: KSService): number => {
  return toNumber(get(servicePlan, `limits.traffic.addon.quantity`, 0))
}

export const getUserCreditAddonQuantity = (servicePlan?: KSService): number => {
  return toNumber(get(servicePlan, `limits.creditUnits.addon.quantity`, 0))
}

export const getUserReqAddonQuantity = (servicePlan?: KSService, isOnCreditPlan?: boolean): number => {
  return isOnCreditPlan ? getUserCreditAddonQuantity(servicePlan) : getUserTrafficAddonQuantity(servicePlan)
}

export const getUserRequestThreshold = (servicePlan?: KSService) => {
  const tierThreshold = get(servicePlan, `limits.traffic.threshold`, 100000)
  const reqPackThreshold = get(servicePlan, `limits.traffic.addon.requests`, 0)
  const reqPackQuantity = toNumber(get(servicePlan, `limits.traffic.addon.quantity`, 0))

  return tierThreshold + reqPackThreshold * reqPackQuantity
}

export const getUserStripeCustomerId = (user: User | DBUser) => get(user, stripeCustomerIdPath)

export const getUserChargifySubscriptionReference = (user: User | DBUser, product: Product = Product.ETHEREUM) => {
  switch (product) {
    case Product.ETHEREUM:
      return `infura_${user.id}`
    case Product.IPFS:
      return `ipfs_${user.id}`
    default:
      return ''
  }
}

export const getUserAddons = (servicePlan?: KSService): Array<ServiceAddon> =>
  (servicePlan?.addons ?? []) as Array<ServiceAddon>

export const userIsSubscribed = (servicePlan?: KSService) => {
  return !isEmpty(getUserAddons(servicePlan)) || getUserSubscriptionTier(servicePlan) !== ServiceTier.CORE
}

const ONE_WEEK = 60 * 60 * 24 * 7
export const needsMfa = (user: User | DBUser, verified: number) => {
  return !!get(user, mfaEnabledPath) && (!verified || new Date().getTime() / 1000 - verified > ONE_WEEK)
}
